import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { Course } from '@/domain/entities/problem/course'
import { CourseSolutionRecord } from '@/domain/entities/problem/courseSolutionRecord'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { CourseHeatMapModuleName } from '@/store/modules/modules'

export class CourseHeatMapViewModel {
  private store = useStore()

  courseStatisticsList: ComputedRef<{ [courseName: string]: { [programLanguage: string]: Course } }> = computed(
    () => this.store.getters[`${CourseHeatMapModuleName}/courseStatisticsList`]
  )
  courseSolutionRecordList: ComputedRef<CourseSolutionRecord[]> = computed(
    () => this.store.getters[`${CourseHeatMapModuleName}/courseSolutionRecordList`]
  )
  courseSolutionRecordListDictionary: ComputedRef<{ [topic: string]: string[] }> = computed(
    () => this.store.getters[`${CourseHeatMapModuleName}/courseSolutionRecordListDictionary`]
  )
  heatMapXLabel: ComputedRef<string[]> = computed(() => this.store.getters[`${CourseHeatMapModuleName}/heatMapXLabel`])
  heatMapSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${CourseHeatMapModuleName}/heatMapSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${CourseHeatMapModuleName}/chartOptions`])
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${CourseHeatMapModuleName}/hasData`])
  isPlotting: ComputedRef<boolean> = computed(() => this.store.getters[`${CourseHeatMapModuleName}/isPlotting`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${CourseHeatMapModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${CourseHeatMapModuleName}/error`])

  async getCourseSolutoinRecordList(userId: string): Promise<void> {
    await this.store.dispatch(`${CourseHeatMapModuleName}/getCourseSolutoinRecordList`, {
      userId
    })
  }

  async getCourseStatisticsListByLanguage(
    courseName: string,
    userId: string,
    programLanguage: ProgramLanguageType
  ): Promise<void> {
    await this.store.dispatch(`${CourseHeatMapModuleName}/getCourseStatisticsListByLanguage`, {
      courseName,
      userId,
      programLanguage
    })
  }

  setCourseStatistics(course: Course, programLanguage: ProgramLanguageType): void {
    this.store.commit(`${CourseHeatMapModuleName}/setCourseStatistics`, {
      course: course,
      programLanguage: programLanguage
    })
  }

  clearCourseStatisticsList(): void {
    this.store.commit(`${CourseHeatMapModuleName}/clearCourseStatisticsList`)
  }

  setCourseSolutoinRecordList(records: CourseSolutionRecord[]): void {
    this.store.commit(`${CourseHeatMapModuleName}/setCourseSolutoinRecordList`, { records: records })
  }

  setCourseSolutoinRecordListDictionary(records: { [topic: string]: string[] }): void {
    this.store.commit(`${CourseHeatMapModuleName}/setCourseSolutoinRecordListDictionary`, { records: records })
  }

  setHeatMapSeries(series: any[]): void {
    this.store.commit(`${CourseHeatMapModuleName}/setHeatMapSeries`, { series: series })
  }

  setHeatMapXLabel(labels: string[]): void {
    this.store.commit(`${CourseHeatMapModuleName}/setHeatMapXLabel`, { labels: labels })
  }

  setChartOptions(options: any): void {
    this.store.commit(`${CourseHeatMapModuleName}/setChartOptions`, { options: options })
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${CourseHeatMapModuleName}/setHasData`, hasData)
  }

  setIsPlotting(isPlotting: boolean): void {
    this.store.commit(`${CourseHeatMapModuleName}/setIsPlotting`, isPlotting)
  }
}
